import { render, staticRenderFns } from "./SeletorDeCargos.vue?vue&type=template&id=13dac3f1"
import script from "./SeletorDeCargos.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeletorDeCargos.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports